import React from 'react';

function InputCont({children}) {
    return (
        <div className='Input-Cont'>
            {children}
        </div>
    );
}

export default InputCont;